import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JssNavItem } from '@core/jss-models';
import { GenericLinkDirective } from '@core/jss-utils';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { NavItemToJssRoutePipe } from '../navbar-item/nav-item-to-jss-route.pipe';

@Component({
  selector: 'wl-navbar-dropdown',
  templateUrl: './navbar-dropdown.component.html',
  styleUrls: [
    './navbar-dropdown.component.ed.scss',
    './navbar-dropdown.component.essent.scss',
  ],
  standalone: true,
  imports: [
    GenericLinkDirective,
    CSCaptureDirective,
    FaIconComponent,
    NavItemToJssRoutePipe,
  ],
})
export class NavbarDropdownComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() item!: JssNavItem;

  @Output()
  clicked = new EventEmitter<JssNavItem>();

  opened = false;

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }
}
